import { render, staticRenderFns } from "./Idpw.vue?vue&type=template&id=eb5c98e6&scoped=true&"
import script from "./Idpw.vue?vue&type=script&lang=js&"
export * from "./Idpw.vue?vue&type=script&lang=js&"
import style0 from "./Idpw.vue?vue&type=style&index=0&id=eb5c98e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5c98e6",
  null
  
)

export default component.exports